import { IAction } from '~/src/store';

import { ESpecOfferActionTypes } from './constants';

export const setIsPopupOpened = (state: boolean): IAction<ESpecOfferActionTypes.setIsPopupOpened, boolean> => ({
    type: ESpecOfferActionTypes.setIsPopupOpened,
    payload: state,
});
